
/**
 * Puente entre el llamado desde JS -> Componente Reactjs (Interfaz)
 * *Descripcion:Namespaces encargado de seleccionar el tipo de componente a ejecutar
 * Patron de diseño: Singleton
 * Creado:22/11/2023
 */
import React from "react";
import { createRoot } from "react-dom/client";
import PrincipalBuscador from "./componentes/PrincipalBuscador"
window.INEGIComponentes || (window.INEGIComponentes = {});
window.INEGIComponentes = {  
        PrincipalBuscador: function (params){
                let ck = window.INEGIComponentes._private.checkParams(params);
                if(ck){
                        const container = document.getElementById(params.id);
                        const root = createRoot(container);
                        root.render(<PrincipalBuscador key={"cibus-"+params.id} id={params.id} />);
                }                        
        },
_private:{
        checkParams:function(params){
                if (params !== undefined) {
                        if (params.id && params.id !== "") {
                                return true;
                        } else {
                                console.warn(params);
                                console.error("No se encontro el id del elemento html.");
                                return false;
                        }
                } else {
                        console.error("No se encuentran los parámetros.");
                        return false;
                }
        }
}        
}